import { Icon } from '../Icon'

/**
 * Пузырь сообщения.
 *
 * Три роли, три разных композиции — «не делать все карточки
 * одинаковыми» из брифа:
 *
 *   чужое     — белая карточка на мягкой тени, слева;
 *   своё      — мятная заливка (accent-light), справа; насыщенный
 *               зелёный пузырь «как в мессенджерах» противоречил бы
 *               спокойному премиуму направления;
 *   системное — строка по центру без пузыря вовсе: «X добавил Y»
 *               не сообщение, а событие ленты.
 *
 * Подпись радиусов асимметрична: угол, обращённый к автору,
 * прижат (r-sm) — лента читается без аватаров.
 *
 * Статусы своего сообщения — язык офлайн-очереди:
 *   queued — часы: лежит в очереди на устройстве, сети нет;
 *   sent   — одна галочка: сервер принял;
 *   read   — двойная галочка мятным: собеседник прочитал;
 *   failed — постоянная ошибка, с кнопкой повтора.
 *
 * Компонент презентационный: время приходит строкой timeLabel,
 * чтобы не тянуть доменное форматирование в ui-пакет.
 */

const STATUS_ICON = {
  queued: 'clock',
  sent: 'check',
  read: 'checkDouble',
}

const STATUS_TITLE = {
  queued: 'В очереди — отправится при появлении связи',
  sent: 'Отправлено',
  read: 'Прочитано',
  failed: 'Не удалось отправить',
}

export function MessageBubble({
  message,
  own = false,
  status = null,          // queued | sent | read | failed | null (чужие)
  timeLabel = '',
  senderName = '',        // показывается для чужих в группе
  onRetry,                // для failed
  onReplyClick,           // навигация к оригиналу цитаты
  children,               // вложения (AttachmentThumb) рендерит экран
}) {
  if (message.kind === 'system') {
    return (
      <div className="msg msg--system" role="status">
        {message.body}
      </div>
    )
  }

  const deleted = message.deleted
  const failed = status === 'failed'

  return (
    <div className={`msg ${own ? 'msg--own' : 'msg--other'}`}>
      <div
        className={[
          'msg__bubble',
          own ? 'msg__bubble--own' : 'msg__bubble--other',
          failed ? 'msg__bubble--failed' : '',
        ].join(' ').trim()}
      >
        {!own && senderName && (
          <div className="msg__sender">{senderName}</div>
        )}

        {message.reply_to && (
          <button
            type="button"
            className="msg__reply"
            onClick={onReplyClick}
            disabled={!onReplyClick}
          >
            <span className="msg__reply-author">
              {message.reply_to.sender?.full_name || 'Сообщение'}
            </span>
            <span className="msg__reply-text">
              {message.reply_to.deleted
                ? 'Сообщение удалено'
                : message.reply_to.body || 'Вложение'}
            </span>
          </button>
        )}

        {deleted ? (
          <div className="msg__deleted">Сообщение удалено</div>
        ) : (
          <>
            {message.body && <div className="msg__body">{message.body}</div>}
            {children}
          </>
        )}

        <div className="msg__meta">
          {timeLabel && <span className="msg__time">{timeLabel}</span>}
          {own && status && !failed && (
            <span
              className={`msg__status msg__status--${status}`}
              title={STATUS_TITLE[status]}
            >
              <Icon name={STATUS_ICON[status]} size={14} />
            </span>
          )}
        </div>
      </div>

      {failed && (
        <div className="msg__failed-row">
          <span>{STATUS_TITLE.failed}</span>
          {onRetry && (
            <button type="button" className="msg__retry" onClick={onRetry}>
              Повторить
            </button>
          )}
        </div>
      )}
    </div>
  )
}
